import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    status: false,
    progressOn : false,
    apiLoading : false,
    apiMessage: null,
    skeleton : true,
    error : false,
};

const apiSlice = createSlice({
    name: 'api',
    initialState,
    reducers: {
        refresh(state, action) {
            state.status = action.payload;
        },
        progressOn(state, action) {
            state.progressOn = true;
        },
        progressOff(state, action) {
            state.progressOn = false;
        },
        setApiMessage(state, action) {
            state.apiMessage = action.payload;
        },
        clearApiMessage(state, action) {
            state.apiMessagen = null;
        },
        error(state, action){
            state.error = true;
            state.apiMessage = action.payload;
        },
        apiLoading(state, action){
            state.apiLoading = action.payload;
        },
        skeleton(state, action){
            state.skeleton = action.payload;
        }
    },
});

export const { refresh,progressOn,progressOff,  error, apiLoading, skeleton,setApiMessage, clearApiMessage } = apiSlice.actions;

export default apiSlice.reducer;
